import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { branch } from 'baobab-react/higher-order';

import utils from '@utils';
import Map from '@components/common/map';
import BLOCKS from '@store/blocks';
import comm from '@utils/comm';
import testingAPI from '@utils/testingGUIAPI';

import { GLIDE } from '../minimap-block/actions';
import {
  COORDS_CHANGE,
  CROSSHAIR_CANCEL,
  CROSSHAIR_MOVE,
  CROSSHAIR_SETUP,
} from './actions';
import { SET_LOCATION } from '@containers/history-panels-block/actions';

import imgTrees from './images/mapTrees.jpg';
import imgNoTrees from './images/mapNoTrees.jpg';

import MAP_CONSTANTS from '../../../constants/map.json';

utils.preloadImages([imgTrees, imgNoTrees]);

const DEFAULT_PARAMS = {
  sizeRatio: MAP_CONSTANTS.main.sizeRatio,
};

const locations = comm.dataStore.locations;
let boundaries = [];
for (let location in locations) {
  if (locations[location].boundaries) {
    boundaries.push({
      x: locations[location].boundaries.xCoords,
      y: locations[location].boundaries.yCoords,
      name: locations[location].internalName,
      displayName: locations[location].displayName,
    });
  }
}
const MapComponent = Map(boundaries);

class MainMap extends Component {
  constructor(props) {
    super(props);

    this.state = { withTrees: false, withLegends: true };
    this.reconParams = comm.dataStore.recon;
    this.prevStep = -1;
    this.prevDiff = 0;

    this.initHandlers();
  }

  initHandlers() {
    const props = this.props;

    this._onGlide = props.dispatch.bind(null, GLIDE);
    this._onCoordsChange = props.dispatch.bind(null, COORDS_CHANGE);
    this.onCrosshairMove = props.dispatch.bind(null, CROSSHAIR_MOVE);
    this.onCrosshairSetup = props.dispatch.bind(null, CROSSHAIR_SETUP);
    this.onCrosshairCancel = props.dispatch.bind(null, CROSSHAIR_CANCEL);

    this._setLocation = props.dispatch.bind(null, SET_LOCATION);

    this.getTests = comm.dataStore.getTestsByName.bind(comm.dataStore);
  }

  render() {
    const props = this.props;
    if (props.visReconStep !== this.prevStep) {
      this.prevDiff = props.visReconStep - this.prevStep;
      this.prevStep = props.visReconStep;
    }

    let visReconCoords;
    if (props.visReconStep > -1) {
      let newSequence;
      if (this.prevDiff > 0) {
        newSequence = this.reconParams[props.visReconStep].coords;
      } else if (this.prevDiff < 0) {
        newSequence = this.reconParams[props.visReconStep + 1].coords
          .slice()
          .reverse();
        newSequence.shift();
        newSequence.push(
          this.reconParams[props.visReconStep].coords[
            this.reconParams[props.visReconStep].coords.length - 1
          ],
        );
      }
      visReconCoords = newSequence.map(idx => comm.dataStore.reconCoords[idx]);
    } else {
      visReconCoords = [];
    }

    return (
      <MapComponent
        zoom={props.zoom}
        coordsStep={10}
        onGlide={this._onGlide}
        width={props.width}
        height={props.width * DEFAULT_PARAMS.sizeRatio}
        onCoordsChange={this._onCoordsChange}
        bitmap={props.withTrees ? imgTrees : imgNoTrees}
        mapDimensions={{
          width: MAP_CONSTANTS.main.width,
          height: MAP_CONSTANTS.main.height,
        }}
        activeTest={props.activeTest}
        markCount={props.marksCount}
        getMarks={this.getTests}
        getTestData={testingAPI.getResults.bind(testingAPI, props.activeTest)}
        settingCrosshairs={props.crosshairsSettingIdx}
        crosshairs={props.crosshairsCoords}
        crosshairPicking={props.crosshairPicking}
        onCrosshairMove={this.onCrosshairMove}
        onCrosshairSetup={this.onCrosshairSetup}
        onCrosshairCancel={this.onCrosshairCancel}
        visReconCoords={visReconCoords}
        curMode={props.curMode}
        curLocation={props.curLocation}
        setLocation={this._setLocation}
        offset={props.offset}
      />
    );
  }
}

MainMap.defaultProps = {
  withTrees: false,
  withLegends: false,
  marksCount: 0,
  width: 1280,
  curLocation: '',
  //height: 800
};

MainMap.propTypes = {
  zoom: PropTypes.number.isRequired,
  offset: PropTypes.object.isRequired,
  withTrees: PropTypes.bool,
  withLegends: PropTypes.bool,
  width: PropTypes.number,
  //height: PropTypes.number,
  activeTest: PropTypes.string,
  marksCount: PropTypes.number,
  crosshairsSettingIdx: PropTypes.number,
  crosshairsCoords: PropTypes.array,
  crosshairPicking: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  visReconStep: PropTypes.number.isRequired,
  curMode: PropTypes.number.isRequired,
  curLocation: PropTypes.string,
};

export default branch(
  {
    cursorPos: BLOCKS.MAP.CURSOR_POSITION,
    offset: BLOCKS.MAP.OFFSET,
    zoom: BLOCKS.MINI_MAP.ZOOM,
    withTrees: BLOCKS.MINI_MAP.WITH_TREES,
    withLegends: BLOCKS.MINI_MAP.WITH_LEGENDS,
    activeTest: BLOCKS.TEST_PANELS.ACTIVE_TEST,
    marksCount: BLOCKS.MAP.MARKER_COUNT,
    crosshairsSettingIdx: BLOCKS.MAP.CROSSHAIR_SETTING,
    crosshairsCoords: BLOCKS.MAP.ACTIVE_MARKERS,
    crosshairPicking: BLOCKS.MAP.PICKING_MARKER,
    visReconStep: BLOCKS.RECON_PANELS.CURRENT_STEP,
    curMode: BLOCKS.MODE.VALUE,
    curLocation: BLOCKS.HISTORY_PANELS.CURRENT_LOCATION,
  },
  MainMap,
);
